<template>
  <div class="componentsList-main-contain">
    <div v-if="propsData.tree" class="componentsList-tree">
      <h3 style="margin-bottom:10px;cursor:pointer;" @click="handleNodeClick">
        图书分类管理
      </h3>
      <el-tree
        ref="applicationTypeTree"
        :data="apptypesTree"
        :props="defaultProps"
        node-key="id"
        highlight-current
        class="filter-tree"
        @node-click="handleNodeClick"
      >
        <span slot-scope="{ node }" class="custom-tree-node" :title="node.label">
          <i class="el-icon-menu" />
          {{ node.label }}
        </span>
      </el-tree>
    </div>
    <div class="applicationType-list">
      <slot />
      <BaseTable
        ref="baseTable"
        v-loading="listLoading"
        class="list-table"
        :columns="columns"
        :data="dataList"
        pag-flag
        @handleCurrentChange="handleSizeChange"
        @selection-change="handleSelectionChange"
      >
        <!-- 操作按钮 -->
        <!-- 租书名称 -->
        <template #rentName="scope">
          <span :title="scope.row.bookName">{{ scope.row.bookName | substring(20) }}</span>
        </template>
        <!-- 封面 -->
        <template #coverImage="scope">
          <el-image
            style="width: 60px; height: 60px"
            :src="scope.row.coverUrl"
            :preview-src-list="[scope.row.coverUrl]"
          />
        </template>
        <!-- 归属分类 -->
        <template #bookTypes="scope">
          <div @click="handleType(scope,'editType')">
            <div v-if="scope.row.types&&scope.row.types.length>0">
              <span v-for="v of scope.row.types" :key="v.firstTypeId" class="typesItem pointer" :title="v.firstTypeName+'/'+v.secondTypeName">{{ v.firstTypeName }} / {{ v.secondTypeName }}</span>
            </div>
            <span v-else class="el-icon-edit-outline icon" />
          </div>
        </template>
        <template #bookTypesFreeBooks="scope">
          <span v-for="v of scope.row.types" :key="v.firstTypeId" class="typesItem" :title="v.firstTypeName+'/'+v.secondTypeName">{{ v.firstTypeName }} / {{ v.secondTypeName }}</span>
        </template>
        <!-- 是否限单 -->
        <template #isLimitFree="scope">
          <div v-for="item in propsData.checkShowList" v-show="scope.row.limitFreeAreas&&scope.row.limitFreeAreas.length>0" :key="item.label">
            {{ scope.row.limitFreeAreas&&scope.row.limitFreeAreas.length>0&&scope.row.limitFreeAreas.indexOf(item.label)!==-1?item.value:'' }}
          </div>
          <span v-show="!(scope.row.limitFreeAreas&&scope.row.limitFreeAreas.length>0)">/</span>
        </template>
        <!-- 图书分类 -->
        <template #defaultType="scope">
          <el-button type="text" size="medium" @click="handleType(scope,'edit')">
            编辑
          </el-button>
          <el-button type="text" size="medium" @click="handleType(scope,'del')">
            删除
          </el-button>
          <el-button v-show="currentSize+scope.index!==1" type="text" size="medium" @click="handleType(scope,'up')">
            上移
          </el-button>
          <el-button v-show="currentSize+scope.index!==searchForm.total" type="text" size="medium" @click="handleType(scope,'down')">
            下移
          </el-button>
        </template>
        <!-- 免费图书 -->
        <template #defaultFree="scope">
          <el-button type="text" size="medium" @click="removeFree(scope)">
            移除
          </el-button>
        </template>
        <!-- 租用次数 -->
        <template #rentCount="scope">
          <el-button type="text" size="medium" @click="rentCountLink(scope.row,scope.row.bookNum,'bookCode')">
            {{ scope.row.rentCount }}
          </el-button>
        </template>
        <!-- 预警监控 -->
        <template #defaultWarn="scope">
          <el-button v-if="scope.row.accountFrozen===0" type="text" size="medium" @click="handleWarn(scope.row,'freeze')">
            冻结
          </el-button>
          <el-button v-if="scope.row.accountFrozen===1" type="text" size="medium" @click="handleWarn(scope.row,'cancelFreeze')">
            取消冻结
          </el-button>
          <el-button type="text" size="medium" @click="handleWarn(scope.row,'detail')">
            查看
          </el-button>
        </template>
        <!-- 预警监控状态 -->
        <template #accountFrozen="scope">
          <span>{{ scope.row.accountFrozen?'冻结':'正常' }}</span>
        </template>
        <!-- 预警监控查看监控规则 -->
        <template #configTypeDetail="scope">
          <span v-if="scope.row.configType===1">自然日（当天阅读不超过{{ scope.row.bookNum }}本）</span>
          <span v-else>时间窗（{{ scope.row.timeInterval }}分内阅读不超过{{ scope.row.bookNum }}本）</span>
        </template>
        <template #bookNum="scope">
          <el-button type="text" size="medium" @click="rentCountLink(scope.row,scope.row.bookNum,'accountPhone')">
            {{ scope.row.bookNum }}
          </el-button>
        </template>
        <!-- 超管账号配置 -->
        <template #defaultWarnAdd="scope">
          <el-button type="text" size="medium" @click="handleWarn(scope.row,'delWarnAdd')">
            删除
          </el-button>
        </template>
      </BaseTable>
    </div>
  </div>
</template>

<script>
import EllaRentBooks from '@/api/userManagement/ellaRentBooks';
import { deepCopy } from '@/utils/index.js';
export default {
  name: 'ReserveRecord',
  props: {
    propsData: {
      type: Object,
      default: Object
    },
    searchForm: {
      type: Object,
      default: Object
    },
    propsColumns: {
      type: Array,
      default: Array
    }
  },
  data() {
    return {
      currentSize: 0, // 当前数据列表的下标
      defaultKey: '', // 当前树默认回现
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      ajaxLoading: false,
      // 搜索表单
      dataList: [],
      multipleSelection: [],
      listLoading: false // 表格刷新loading
    };
  },
  computed: {
    // 表格表头
    columns() {
      return this.propsColumns;
    },
    apptypesTree() {
      if (this.propsData.unautoLoading) { // 图书列表
        const list = deepCopy(this.$store.state.ella.apptypesTree);
        list.push({
          id: '00000',
          name: '未分类'
        });
        return list;
      } else {
        return this.$store.state.ella.apptypesTree;
      }
    }
  },
  watch: {
    // 路由监听赋值三级菜单
    propsData: {
      handler: function(val, oldVal) {
        this.init();
      },
      // $route这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  mounted() {
    // this.init();
  },
  methods: {
    // 初始化
    init() {
      this.fetchdataList();
    },
    // 图书分类操作按钮
    handleType(scope, type) {
      if (type === 'del') {
        this.$confirm(
          `确定要删除?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          this.handlerApi('get_types_del', '删除成功!', scope.row.id, 'tree');
        });
      } else if (type === 'up') {
        this.handlerApi('get_types_moveup', '移动成功!', scope.row.id, 'tree');
      } else if (type === 'down') {
        this.handlerApi('get_types_movedown', '移动成功!', scope.row.id, 'tree');
      } else if (type === 'edit') {
        this.$emit('edit', scope.row.id);
      } else if (type === 'editType') {
        this.$emit('editLinkType', scope.row);
      }
    },
    // 租用次数监控次数连接到租书记录列表
    rentCountLink(row, val, op) {
      // if (val > 0) {
      this.$store.commit('SET_ELLAACTIVENAME', 'first');
      this.$store.commit('SET_LINKRENTBOOKQUERY', { [op]: row[op] });
      // }
    },
    // 免费图书操作按钮
    removeFree(scope) {
      this.$confirm(
        `确定要移除?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        const code = this.searchForm.limitFreeArea && parseInt(this.searchForm.limitFreeArea);
        this.handlerApi(this.propsData.del, '移除成功!', { ids: [scope.row.id], limitFreeAreas: [code] });
      });
    },
    // 预警监控操作按钮
    handleWarn(row, type) {
      if (type === 'freeze') {
        this.handlerApi('get_warnings_freeze', '冻结成功!', row.id);
      } else if (type === 'cancelFreeze') {
        console.log('cancelFreeze');
        this.handlerApi('get_warnings_unfreeze', '取消冻结成功!', row.id);
      } else if (type === 'detail') {
        this.$emit('detailEmit', { accountId: row.accountId, accountPhone: row.accountPhone });
      } else if (type === 'delWarnAdd') {
        this.$confirm(
          `确定要删除?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          this.handlerApi('get_whitelists_del', '删除成功!', row.id);
        });
      }
    },
    // 表格选择事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 树点击事件
    handleNodeClick(data, node, el) {
      if (data.id) {
        if (this.propsData.unautoLoading) { // 图书管理列表点击树字段ellabookTypeId
          this.searchForm.ellabookTypeId = data.id;
        } else {
          this.searchForm.pid = data.id;
        }
        this.defaultKey = data.id;
      } else {
        if (this.propsData.unautoLoading) { // 图书管理列表点击树字段ellabookTypeId
          this.searchForm.ellabookTypeId = '';
        } else {
          this.searchForm.pid = '';
        }
        this.defaultKey = '';
      }
      this.fetchdataList();
    },
    // 分页条数变化
    handleSizeChange() {
      const { pageNum, pageSize } = this.$refs['baseTable'].pageObj;
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.fetchdataList();
    },
    // 公共APi调用
    async handlerApi(api, msg, op, type) {
      const _self = this;
      try {
        const res = await EllaRentBooks[api](op);
        if (res.code === '0') {
          this.$message({
            type: 'success',
            message: msg
          });
          if (type && type === 'tree') {
            this.$store.dispatch('fetchAppBooKtypesTree').then(() => {
              _self.fetchdataList();
            });
          } else {
            this.fetchdataList();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取应用列表
    fetchdataList() {
      this.listLoading = true;
      var op = deepCopy(this.searchForm);
      op.time = op.total = op.paytime = null;
      EllaRentBooks[this.propsData.api](op)
        .then(result => {
          if (result.code === '0' && result.data && result.data.list && result.data.list.length > 0) {
            this.listLoading = false;
            const { list, pageNum, pageSize, total } = result.data;
            this.dataList = list;
            this.searchForm.total = total;
            this.$refs['baseTable'].setPage({ pageNum, pageSize, total });
            this.searchForm.pageNum = pageNum;
            this.searchForm.pageSize = pageSize;
            this.currentSize = (this.searchForm.pageNum - 1) * this.searchForm.pageSize + 1; // 获取列表数据中当前位置
          } else {
            this.dataList = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.dataList = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.componentsList-main-contain {
  display: flex;
  padding-top: 10px;
  margin-left: 10px;
  .componentsList-tree {
    width: 200px;
    margin-right: 20px;
    .filter-tree {
      font-size: 15px;
      .custom-tree-node {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  .applicationType-list {
    flex: 1;
  }
.handle-form-input {
  width: 80%;
  }
  .icon{font-size: 24px; color: #409EFF;display: block;text-align: center;}
  .typesItem {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
    display: inline-block;
    -webkit-line-clamp: 1;
  }
  .pointer {
    cursor: pointer;
  }
}

</style>
